import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityDownloadExport } from '../../projectDetailsActivities.models';

export const DownloadExportActivity = ({ values }: IProjectActivity<IProjectActivityDownloadExport>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_Download_Export.body', {
        ...values,
        selectedFilter: t(`activity_description_Download_Export.filter_types.${values.dataFilterType}`),
      })}
    </span>
  );
};
